import objectAssign from 'object-assign'
import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'
import routes from './router'
import store from './store/'
import vuexI18n from 'vuex-i18n'
import vuxLocales from './locales/all.yml'
import componentsLocales from './locales/components.yml'


Vue.use(vuexI18n.plugin, store, {
moduleName: 'wesley',
translateFilterName: 't'
})
const finalLocales = {
'en': objectAssign(vuxLocales['en'], componentsLocales['en']),
'zh-CN': objectAssign(vuxLocales['zh-CN'], componentsLocales['zh-CN'])
}
for (let i in finalLocales) {
Vue.i18n.add(i, finalLocales[i])
}
Vue.i18n.set('en')

import util from './util'
import * as ajax from './util/ajax'
import WoxVueScroll from 'wox-vue-scroll'
import conf from './util/conf'
import func from './util/func'
import token_conf from './util/token_conf'

import sku from './util/sku'
import maps from './util/maps'
import order from './util/order'
import VueIphonex from 'vue-iphonex'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LocalePlugin from 'vux/src/plugins/locale/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import querystring from 'vux/src/tools/querystring/index.js'
import ConfigPlugin from 'vux/src/plugins/config/index.js'


import VueBetterScroll from 'vue2-better-scroll'
import VueLazyload from 'vue-lazyload'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueClipboard from 'vue-clipboard2'
import wx from 'vue-weixin-js-sdk'
import payLayer from "vue-pay-layer"

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

Vue.use(payLayer)
Vue.use(VueIphonex)
Vue.use(VueClipboard)
Vue.use(WoxVueScroll)

Vue.use(VueBetterScroll)

Vue.use(ToastPlugin)
Vue.use(VueRouter)
Vue.use(LocalePlugin)
Vue.use(ConfirmPlugin)
Vue.use(AlertPlugin)
Vue.use(ConfigPlugin, {
$layout: 'VIEW_BOX'
})



Vue.use(VueLazyload, {
preLoad: 1.3,
loading: require('assets/images/common/blank.png'),
attempt: 1,
/*error: 'dist/error.png',
loading: 'dist/loading.gif',*/

})
Vue.use(VueGoogleMaps, {
load: conf.google_map
})

import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast, {
position: 'top-left',
});
Vue.prototype.wx = wx
Vue.prototype.querystring = querystring
Vue.prototype._ajax = ajax
Vue.prototype._conf = conf
Vue.prototype._func = func
Vue.prototype.token_conf = token_conf
Vue.prototype._sku = sku
Vue.prototype._maps = maps
Vue.prototype._order = order
Vue.prototype._middle = new Vue({})
Vue.prototype._fromGo = {
path: '',
fullPath: '',
name: ''
}
Vue.prototype._fromHistory = {
list: [],
flag: true
}
Vue.prototype.platform = func.platform()
Vue.prototype._util = util

util.initLang(Vue)

if (process.env.NODE_ENV == 'development') {
Vue.config.devtools = true
} else {
Vue.config.productionTip = false

Vue.config.devtools = false
if (process.env.MONITOR) {
Sentry.init({
Vue,
environment: process.env.NODE_ENV,
release: process.env.VERSION,
dsn: 'https://07b0a62732f2426f9664b1a415661e3b@o951765.ingest.sentry.io/5901062',
integrations: [new Integrations.BrowserTracing({


})],

});
}
}
window.moment = require('moment')

/*if ('addEventListener' in document){
document.addEventListener('DOMContentLoaded', function(){
FastClick.attach(document.body)
}, false)
}*/
const router = new VueRouter({
routes,
mode: process.env.NODE_ENV == 'app' ? '' : 'history'
})



router.beforeEach(function(to, from, next) {
if (from.meta.scrollTop !== undefined) {
if (from.meta.name) {
if (document.querySelector(from.meta.name)) {
from.meta.scrollTop = document.querySelector(from.meta.name).scrollTop
} else {
from.meta.scrollTop = 0
}
} else {
from.meta.scrollTop = document.documentElement.scrollTop
}
}
if (from.name != to.name && from.fullPath != to.fullPath) {
Vue.prototype._fromGo = from
if (Vue.prototype._fromHistory.flag) {
if (Vue.prototype._fromHistory.list[Vue.prototype._fromHistory.list.length - 1] != from.fullPath) {
if (from.fullPath.indexOf('/member/login') < 0) {
Vue.prototype._fromHistory.list.push(from.fullPath)
Vue.prototype._fromHistory.list = Vue.prototype._fromHistory.list.slice(-20)
}
}
}
Vue.prototype._fromHistory.flag = true
}
if (window.__wxjs_is_wkwebview) {
if (window.entryUrl == '' || window.entryUrl == undefined) {
var url = window.location.protocol + '//' + window.location.host + to.fullPath
window.entryUrl = url
Vue.prototype.req_url = (window.entryUrl)
}
} else {
Vue.prototype.req_url = (window.location.protocol + '//' + window.location.host + to.fullPath)
}
if (to.matched.some(m => m.meta.requiresAuth) && !store.state.userInfo.uid) {
if(to.meta && to.meta.passAuth){
next()
}else{
if (window.__wxjs_is_wkwebview) {
window.entryUrl = window.location.protocol + '//' + window.location.host + '/member/login?redirect=' + encodeURIComponent(to.fullPath)
Vue.prototype.req_url = window.entryUrl
}
let p = {}
if (to.query.m) {
p.m = to.query.m
}
p.redirect = to.fullPath
router.push({
path: '/member/login',
query: p
},()=>{})
/*next({
path: '/member/login',
query: p
},()=>{})*/
}
} else {
next()
}
})

router.afterEach((to, from) => {
if (window.ga) {
window.ga('set', 'page', to.fullPath)
window.ga('send', 'pageview')
}
})
/*if (process.env.NODE_ENV == 'app') {
document.addEventListener('deviceready', function() {
store.commit('SET_DEVICE', device)
}, false)
}*/

/*const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
return originalPush.call(this, location).catch(err => err)
}*/

new Vue({
store,
router,
render: h => h(App)
}).$mount('#app')
